import { useMutation } from '@tanstack/react-query';
import { LoginApi } from '../../../apis/LoginApi/LoginApi.ts';

export function usePostChangePasswordMutation() {
    return useMutation<string, Error, { oldPassword: string; newPassword: string }>({
        mutationFn: async ({ oldPassword, newPassword }) => {
            return LoginApi.changePassword({ oldPassword, newPassword });
        },
    });
}
